import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/AuthProvider";
import { NEUTRAL, STATUS, SURFACE } from "../../theme/tokens";

const ENV = import.meta.env.VITE_ENVIROMENT || "development";
const IS_PRODUCTION = ENV === "production";

export const ProductionEnvBanner = () => {
	const { userInfo } = useAuth();
	const { t } = useTranslation();

	if (!IS_PRODUCTION) return null;
	if (!(userInfo?.support || userInfo?.impersonated_by)) return null;

	return (
		<Box
			role="status"
			aria-live="polite"
			data-testid="production-env-banner"
			sx={{
				width: "100%",
				bgcolor: NEUTRAL[900],
				color: SURFACE,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				gap: 0.75,
				px: 2,
				py: 0.25,
				textAlign: "center",
			}}
		>
			<WarningAmberIcon sx={{ color: STATUS.WARNING.main, fontSize: 16 }} />
			<Typography variant="caption" sx={{ fontWeight: 500, lineHeight: 1.4, letterSpacing: 0.2 }}>
				{t("support_user_production_warning")}
			</Typography>
		</Box>
	);
};
